import { render } from "./App.vue?vue&type=template&id=871e0d68"
const script = {}

import "./App.vue?vue&type=style&index=0&id=871e0d68&lang=scss"

import exportComponent from "/media/myr/DATA/WEBS/DULCESDE.COM/NUEVA WEB 2022/vue_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__